<template>
  <div class="im-dialog">
    <div class="im-dialog__col-left" @mouseup="mouseup" >
      <Messages/>
    </div>
    <div class="im-dialog__col-right">
      <Info/>
    </div>
  </div>
</template>

<script>
  import Messages from './messages/Messages.vue';
  import Info from './info/Info.vue';

  export default {
    name: 'Dialog',
    components: {
      Messages,
      Info
    },
    methods: {
      mouseup(){
        var selObj = window.getSelection();
        var selectedText = selObj.toString();
        this.$store.dispatch('addSelectedTextDialog', selectedText);
      },
    },
  };
</script>

<style lang="scss">
  .im-dialog {
    display: flex;
    flex-shrink: 1;

    &__col-left {
      box-sizing: border-box;
      border: 1px solid #D6D6D6;
      margin: 20px;
      padding: 0;
      width: calc(100% - 212px);
      position: relative;
    }

    &__col-right {
      box-sizing: border-box;
      border: 1px solid #D6D6D6;
      margin: 20px 20px 20px 0;
      padding: 20px;
      width: 212px;
      position: relative;
    }
  }
</style>